import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import MailEditor from "./MailEditor";

const CreateMail = () => {
    const dispatch = useDispatch();

    const { isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.mails
    );

    useEffect(() => {
        if (isError) {
            if (errors) {
                toast.error("error");
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
        }
        if (isSuccess) {
            toast.success("Mail sent successfully");
        }
    }, [errors, isError, isSuccess]);

    return (
        <MailEditor
            dispatch={dispatch}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            errors={errors}
        ></MailEditor>
    );
};

export default CreateMail;
